module.exports = __webpack_public_path__ + "static/media/balmain_8.b7540222.jpg";